export class ProfileUndefinedException extends Error {

  constructor(message: string) {
    super(message);
    this.name = "ProfileUndefinedException";
  }

}
